const SEO_FALLBACK_ATTR = 'data-seo-fallback'

let cleared = false

/**
 * On React 19, react-helmet-async renders native head tags and does not remove
 * static shell tags. Mark shell SEO with data-seo-fallback and call this once
 * when a page Helmet mounts so fallbacks are replaced, not duplicated.
 */
export function clearShellSeoFallbacksOnce(): void {
    if (cleared || typeof document === 'undefined') return
    cleared = true
    document.querySelectorAll(`[${SEO_FALLBACK_ATTR}]`).forEach(el => el.remove())
}
